import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminShipmentSizeType } from '../../enums/admin-shipment-size-type';
import { AdminShipmentSizeTypePipe } from '../../pipes/admin-shipment-size-type.pipe';

@Component({
  selector: 'app-admin-shipment-size-type',
  imports: [CommonModule, AdminShipmentSizeTypePipe],
  templateUrl: './admin-shipment-size-type.component.html',
  styleUrl: './admin-shipment-size-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminShipmentSizeTypeComponent {
  public readonly size = input.required<AdminShipmentSizeType>();
}
